import { getElement } from '@Utils/Elements.js';
import Options from '@Assets/ElementOptions.json';
import { simplifyFeature, isFeatureClosed, close } from '@Utils/FeatureUtils.js';


function shouldHide(arr1, arr2) {
	/// if not arrays then return false

	if (!arr2 || !arr1) {
		return false;
	}
	if (arr1.some === undefined || arr2.includes === undefined) {
		return false;
	}
	/// return true if either array contains something from the 
	return arr1.some((a) => arr2.includes(a))
}
export class ElementFeature {
	feature;
	constructor(feature) {
		this.feature = feature;
	}
	simplify(value) {
		if(this.getElementName() === 'flatroofbuilding') {
			let coordinates = this.feature.getGeometry().getCoordinates()[0];
			if(coordinates.length < 4) {
				return
			}
			/// loop through the coordinates and make each corner 90 degrees by measuring the angle between the two lines
			let newCoordinates = []
			let angle = Math.PI / 2
			for(let i = 0; i < coordinates.length; i++) {
				let p1 = coordinates[i]
				let p2 = coordinates[(i + 1) % coordinates.length]
				let p3 = coordinates[(i + 2) % coordinates.length]
				let v1 = [p2[0] - p1[0], p2[1] - p1[1]]
				let v2 = [p3[0] - p2[0], p3[1] - p2[1]]
				let angle = Math.atan2(v2[1], v2[0]) - Math.atan2(v1[1], v1[0])
				// if(angle != 90) {
				// 	angle = Math.PI / 2 - angle
				// }
				let newP2 = [p2[0] + Math.cos(angle) * 10, p2[1] + Math.sin(angle) * 10]
				newCoordinates.push(p1, newP2)
			}
			this.feature.getGeometry().setCoordinates([newCoordinates])
		} else {
			simplifyFeature(this.feature, value);
		}
	}
	setRounded(value) {
		this.feature.set('rounded', value);
	}
	setElementStyle(value) {
		let el = getElement(value);
		if (el) {
			this.feature.set('elementName', value);
		}
	}
	isClosed() {
		return isFeatureClosed(this.feature);
	}
	close() {
		close(this.feature);
	}
	setOption(name, value, ignoreCache = false) {
		// if (!['pointsPerSeg', 'tension', 'shadeoffset', 'shadeamount', 'normalize', 'rounded', 'elementName', 'hidden', 'textureRotation', 'textureSize', 'textureRef'].includes(name)) {
		// 	return;
		if(!ignoreCache) {
			this.feature.set('clearCache', true)
		}
		let element = this.getElement()
		if (name === 'placeabove') {
			let index = element.zIndex
			if (value) {
				let placeover = getElement(value);

				if (placeover) {
					index = placeover.zIndex + 1
				}
			}
			this.feature.set('order', index);
		}
		if (value === undefined || value === null || value === "") {
			this.feature.unset(name);
		} else {
			this.feature.set(name, value);
		}
	}
	getOption(name, def) {
		if (def === undefined) {
			let el = this.getElement();
			if (el && el.defaultValues && el.defaultValues[name] !== undefined) {
				def = el.defaultValues[name]
			}
		}
		let v = this.feature.get(name)
		if (v !== undefined) {
			return v
		}
		return def;
	}
	getElementName() {
		return this.feature.get('elementName');
	}
	hasMaxPointConstraints() {
		let el = this.getElement();
		if (el && el.constraints && el.constraints.maxPoints) {
			return true;
		}
		return false;
	}
	getElement() {
		return getElement(this.getElementName());
	}
	getId() {
		return this.feature.ol_uid;
	}
	setHidden(value) {
		return this.feature.set('hidden', value);
	}
	getType() {
		return this.feature.getGeometry().getType();
	}
	getOptions(subscription) {
		let el = this.getElement();
		if(!el) {
			return null;
		}
		if(subscription) {
			return Options.filter((o) => 
				(o.targets.includes(el.tooltype) || o.targets.includes(el.options) || o.targets.includes(el.name)) && (!o.subscriptions || o.subscriptions.includes(subscription))
			);	
		}
		return Options.filter((o) => (o.targets.includes(el.tooltype) || o.targets.includes(el.options) || o.targets.includes(el.name)))
	}
	resetToDefaults(subscription, ignoreCache = false, protectionLevel = 0, fillValues = false) {
		let options = this.getOptions(subscription);
		if (!options) {
			return;
		}
		for (let option of options) {
			for (let field of option.fields) {
				if(field.protectionLevel && field.protectionLevel > protectionLevel) {
					continue
				}
				this.setOption(field.name, fillValues ? field.default : null, ignoreCache);
			}
		}
		if(ignoreCache) {
			this.feature.unset('selected');
			this.feature.unset('focused');
			this.feature.unset('hidden');
			this.feature.unset('unfinished');
			this.feature.unset('overlapping')
			this.feature.unset('clearCache')
			this.feature.unset('intersecting')
			this.feature.unset('modifyGeometry')
			/// unused properties
			this.feature.unset('convex')
		}
	}
	getValue(name) {
		return this.feature.get(name);
	}
	getValues(advanced, subscription) {
		let options = this.getOptions(subscription);
		if (!options) {
			return null;
		}
		let el = this.getElement();
		let hideArguments = [el.tooltype, el.options, el.name, subscription].filter((a) => a !== undefined)

		options = JSON.parse(JSON.stringify(options));
		for (let option of options) {
			if (option.subscriptions && option.subscriptions.includes(subscription) === false) {
				continue;
			}
			for (let field of option.fields) {
				let name = field.name
				let _default = field.default
				if (el.defaultValues && el.defaultValues[name] !== undefined) {
					_default = el.defaultValues[name]
				}
				field.value = this.getOption(field.name, _default);
				if(field.hidden !== true) {
					field.hidden = shouldHide(hideArguments, field.hiddenFor);
				}
			}
			if (advanced !== true) {
				option.fields = option.fields.filter((f) => f.enabledBy !== "advanced");
			}
		}
		return options;
	}
	getValuesAsObject(advanced, subscription) {
		let values = this.getValues(advanced, subscription);
		let obj = {};
		for (let option of values) {
			if (option.subscriptions && option.subscriptions.includes(subscription) === false) {
				continue;
			}
			for (let field of option.fields) {
				obj[field.name] = field.value;
			}
		}
		return obj;
	}
	static createDefaultValues(element) {
		let options = ElementFeature.getOptions(element);
		let values = {};
		for (let option of options) {
			for (let field of option.fields) {
				values[field.name] = field.default;
			}
		}
		return values;
	}
}
